export enum Institution {
  csf = 'csf',
  insieme = 'insieme'
}
